export const ProjectActionTypes = {
    FETCHING_PROJECTS_START: 'FETCHING_PROJECTS_START',
    FETCHING_PROJECTS_SUCCESS: 'FETCHING_PROJECTS_SUCCESS',
    FETCHING_PROJECTS_FAILURE: 'FETCHING_PROJECTS_FAILURE',
    SET_PROJECTS_QUERY: 'SET_PROJECTS_QUERY',
    SET_PROJECTS: 'SET_PROJECTS',
    SET_PROJECT_COUNTS: 'SET_PROJECT_COUNTS',
    SET_PROJECTS_USERS: 'SET_PROJECTS_USERS',
    SET_PROJECTS_GROUPS: 'SET_PROJECTS_GROUPS',
    ADD_SELECTED_PROJECT: 'ADD_SELECTED_PROJECT',
    DELETE_SELECTED_PROJECT: 'DELETE_SELECTED_PROJECT',
    ADD_MULTIPLE_SELECTED_PROJECTS: 'ADD_MULTIPLE_SELECTED_PROJECTS',
    DELETE_MULTIPLE_SELECTED_PROJECTS: 'DELETE_MULTIPLE_SELECTED_PROJECTS',
    SET_SELECTED_PROJECT: 'SET_SELECTED_PROJECT',
    SET_GROUP_PROJECTS_BY: 'SET_GROUP_PROJECTS_BY',
    SET_PROJECTS_GROUPED: 'SET_PROJECTS_GROUPED',
    SET_FILTERED_AND_SORTED_PROJECTS: 'SET_FILTERED_PROJECTS',
    SET_SHOW_ACTIVE: 'SET_SHOW_ACTIVE',
    SET_SHOW_COMPLETED: 'SET_SHOW_COMPLETED',
    SET_SHOW_ARCHIVED: 'SET_SHOW_ARCHIVED',
    SET_VIEW_ALL_ACTIVE_ROWS: 'SET_VIEW_ALL_ACTIVE_ROWS',
    SET_VIEW_ALL_COMPLETED_ROWS: 'SET_VIEW_ALL_COMPLETED_ROWS',
    SET_VIEW_ALL_ARCHIVED_ROWS: 'SET_VIEW_ALL_ARCHIVED_ROWS',
    RESET_PROJECTS: 'RESET_PROJECTS',
}

export const ProjectCountActionTypes = {
    FETCHING_PROJECTS_COUNT_START: 'FETCHING_PROJECTS_COUNT_START',
    FETCHING_PROJECTS_COUNT_SUCCESS: 'FETCHING_PROJECTS_COUNT_SUCCESS',
    FETCHING_PROJECTS_COUNT_FAILURE: 'FETCHING_PROJECTS_COUNT_FAILURE',
    SET_PROJECTS_COUNT: 'SET_PROJECTS_COUNT',
    RESET_PROJECTS_COUNT: 'RESET_PROJECTS_COUNT',
}

export const ProjectUsersAndGroupsActionTypes = {
    FETCHING_PROJECTS_USERS_AND_GROUPS_START: 'FETCHING_PROJECTS_USERS_AND_GROUPS_START',
    FETCHING_PROJECTS_USERS_AND_GROUPS_SUCCESS: 'FETCHING_PROJECTS_USERS_AND_GROUPS_SUCCESS',
    FETCHING_PROJECTS_USERS_AND_GROUPS_FAILURE: 'FETCHING_PROJECTS_USERS_AND_GROUPS_FAILURE',
    SET_PROJECTS_USERS: 'SET_PROJECTS_USERS',
    SET_PROJECTS_GROUPS: 'SET_PROJECTS_GROUPS',
    RESET_PROJECTS_USERS_AND_GROUPS: 'RESET_PROJECTS_USERS_AND_GROUPS',
}
